import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const myTeamsRoutes: FuseRouteItemType[] = [
	{
		path: 'my-teams',
		children: [
			{
				index: true,
				element: <LegacyRouteRedirect to="/teams" />
			},
			{
				path: ':id',
				element: <LegacyRouteRedirect to="/teams/:id" />
			}
		]
	}
];

export default myTeamsRoutes;
